<script lang="ts">
	import type { ArticleCard } from "#lib/types/shared.js";
	import ListArticles from "#lib/ListArticles.svelte";
	import MetaData from "#lib/MetaData.svelte";

	interface Props {
		data: {
			articles?: Readonly<ArticleCard>[];
		};
	}

	let { data }: Props = $props();
	let articles = $derived(Array.isArray(data?.articles) ? data.articles : []);
</script>

<MetaData
	data={{
		title: "Aktuelt",
		description: "Her finner du nyheter og informasjon om hva som skjer i Ishavskraft.",
	}}
	jsonLd={true}
	itemList={articles.map((a) => ({
		"@type": "Article",
		headline: a.title,
		name: a.title,
		// Lowercase to match the sitemap and the URL the route serves; slugs
		// are written with capitals in Sanity.
		url: `https://www.ishavskraft.no/om/aktuelt/${a.slug.current?.toLowerCase()}`,
		image: a.image?.src,
		datePublished: a.publishedAt,
		description: a.lead,
	}))}
/>

<ListArticles listTitle="Aktuelt" {articles} displayFields={{ date: true }} />
